module.exports = __webpack_public_path__ + "img/keypoints_guide_pore_icon.ad895775.png";